const phoneUtils = {
  formatPhoneString: (phone: string) => {
    if (!phone) {
      return '';
    }

    let ext = '';
    let replacedPhone = phone;

    if (phone.indexOf('#') !== -1) {
      ext = phone.slice(phone.indexOf('#'), phone.length);
      replacedPhone = phone.slice(0, phone.indexOf('#'));
    }

    replacedPhone = ('' + replacedPhone)
      .replace(/[^\d*]/g, '')
      .replace(
        /(\d|\*)(\d|\*)(\d|\*)(\d|\*)(\d|\*)(\d|\*)(\d|\*)(\d|\*)(\d|\*)(\d|\*)(\d|\*)/,
        (match, p1, p2, p3, p4, p5, p6, p7, p8, p9, p10, p11) => {
          return `+${p1} ${p2}${p3}${p4} ${p5}${p6}${p7}-${p8}${p9}-${p10}${p11}`;
        },
      );

    if (ext) {
      replacedPhone += ` ${ext}`;
    }

    return replacedPhone;
  },
  isPhoneLikeInput: (value: string): boolean => /^[0-9\s+()#-]+$/.test(value.trim()),
  isValidPhone: (value: string): boolean => {
    const raw = value.replace(/[^\d]/g, '');
    return raw.length >= 10 && raw.length <= 15;
  },
  normalizePhone: (value: string): string => {
    const digits = value.replace(/[^\d+]/g, '');
    const raw = digits.replace(/^\+/, '');
    if (raw.length === 10) return `+7${raw}`;
    if (raw.length === 11 && (raw[0] === '8' || raw[0] === '7')) return `+7${raw.slice(1)}`;
    return digits.startsWith('+') ? digits : `+${digits}`;
  },
  searchPhoneNumber: (input: string, label?: string) => {
    const regex = /[\s-()]/g;

    return (label ?? '')
      .toLowerCase()
      .replace(regex, '')
      .includes(input.replace(regex, '').toLowerCase());
  },
};

export { phoneUtils };
